import Newsletter_37Container from "./container/Newsletter_37Container";
export default Newsletter_37Container;
